import React from "react";
import ReactMarkdown from "react-markdown";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import SEO from "@/components/shared/SEO";
import { useI18n } from "@/context/I18nContext";

import cleanerCodeEn from "@/content/agreements/cleaner_code_v1_en.md";
import cleanerCodeEs from "@/content/agreements/cleaner_code_v1_es.md";

// Cleaner Code of Conduct — the rules every approved cleaner accepts when
// joining the platform. Updates to this document live in /src/content/agreements
// and require a code deploy (so we have a permanent record of the version
// each applicant accepted).
export default function CleanerAgreementPage() {
  const { locale } = useI18n();
  const body = locale === "es" ? cleanerCodeEs : cleanerCodeEn;
  const reviewed = new Date().toLocaleDateString(locale === "es" ? "es-ES" : "en-US", {
    year: "numeric", month: "long", day: "numeric",
  });
  const title = locale === "es" ? "Código de Conducta del Limpiador — Ever Clean Home" : "Cleaner Code of Conduct — Ever Clean Home";
  const desc = locale === "es"
    ? "Reglas que aceptan los limpiadores aprobados de Ever Clean Home. Borrador pendiente de revisión legal."
    : "The rules every approved Ever Clean Home cleaner accepts. Draft pending legal review.";
  const footerNote = locale === "es"
    ? `Última revisión: ${reviewed}. Para preguntas legales específicas, contactar legal@evercleanhome.online.`
    : `Last reviewed: ${reviewed}. For specific legal questions, contact legal@evercleanhome.online.`;

  return (
    <div className="min-h-screen bg-[#FAFAF9]" data-testid="cleaner-agreement-page">
      <SEO title={title} description={desc} noindex />
      <Header />
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-16 prose prose-stone prose-headings:font-display prose-headings:tracking-tight prose-h1:text-4xl prose-h1:font-extrabold">
        <ReactMarkdown>{body}</ReactMarkdown>
        <p className="text-xs text-[#9CA3AF] mt-10 not-prose" data-testid="cleaner-agreement-footer-note">
          <em>{footerNote}</em>
        </p>
      </div>
      <Footer />
    </div>
  );
}
